export default __webpack_public_path__ + "static/media/mansoor majeed biodata.7f7c8c60.pdf";